<template>
  <span :data-test="`recruiter-ownership-days-${rowIndex}`">{{ column.recruiterOwnershipDays ?? '-' }}</span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'

const CompanyRecruiterOwnershipColumn = graphql(`
  fragment CompanyRecruiterOwnershipColumn on CompanyRecruiter {
    recruiterOwnershipDays
  }
`)

const props = defineProps<{
  row: FragmentType<typeof CompanyRecruiterOwnershipColumn>
  rowIndex?: number
}>()
const column = computed(() => useFragment(CompanyRecruiterOwnershipColumn, props.row))
const rowIndex = computed(() => props.rowIndex ?? 0)
</script>
